// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__GbL59","buttons":"PendingPaymentAlert_buttons__3PPGz"};